import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-12dbb514"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register" }
const _hoisted_2 = { class: "signup" }
const _hoisted_3 = { class: "organization" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Sign Up", -1))
const _hoisted_5 = { class: "form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "E-Mail", -1))
const _hoisted_7 = { class: "inputWrapper" }
const _hoisted_8 = {
  key: 0,
  class: "error"
}
const _hoisted_9 = { class: "form" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Password", -1))
const _hoisted_11 = { class: "inputWrapper" }
const _hoisted_12 = { class: "form" }
const _hoisted_13 = { class: "verify_label" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Verify Code", -1))
const _hoisted_15 = {
  key: 1,
  class: "countdown"
}
const _hoisted_16 = { class: "inputWrapper" }
const _hoisted_17 = { class: "form" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, null, -1))
const _hoisted_19 = { class: "inputWrapper" }
const _hoisted_20 = { class: "join" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.visible,
    "before-close": _ctx.handleClose,
    center: "",
    width: "416px",
    style: {"height":"512px","border-radius":"16px"},
    "append-to-body": true,
    "append-to": "body",
    "modal-class": "new-modal-class"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event)),
                  class: "input",
                  placeholder: "Please input email"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.isValidEmail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.isValidEmail), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_input, {
                  type: "password",
                  modelValue: _ctx.formData.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event)),
                  class: "input",
                  placeholder: "Please input password"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                (_ctx.countdown === 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSendCode && _ctx.handleSendCode(...args))),
                      class: "sent"
                    }, "Sent"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, "countdown: " + _toDisplayString(_ctx.countdown), 1))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.verifyCode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.verifyCode) = $event)),
                  class: "input",
                  placeholder: "Please input verifyCode"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_el_button, {
                    onClick: _ctx.handleSubmit,
                    class: "button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Register")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "before-close"]))
}